import { ENUM_QUALIFY_QUESTION_TYPES } from "../../../../enums";

/**
 * Formats a value that can be a string, array, or null into a string array
 */
export const formatArrayField = (
  value: string | string[] | null | undefined
): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    return value.split(",").map((item) => item.trim()).filter(Boolean);
  }
  return [];
};

/**
 * Formats keywords that can be objects with label property or strings
 */
export const formatKeywords = (
  value: string | string[] | any[] | null | undefined
): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value
      .map((item: any) => (typeof item === "object" ? item?.label : item))
      .filter((item: any) => item && String(item).trim() !== "");
  }
  if (typeof value === "string") {
    return value
      .split(",")
      .map((item: string) => item.trim())
      .filter((item: string) => item !== "");
  }
  return [];
};

/**
 * Gets the human-readable label for a question type
 */
export const getQuestionTypeLabel = (type: string): string => {
  switch (type) {
    case ENUM_QUALIFY_QUESTION_TYPES.SHORT_TEXT:
      return "Short Text";
    case ENUM_QUALIFY_QUESTION_TYPES.BOOLEAN:
      return "Yes/No";
    case ENUM_QUALIFY_QUESTION_TYPES.MULTI_SELECT:
      return "Multi Select";
    default:
      return type;
  }
};

/**
 * Transforms questions object into a sorted array of question entries
 */
export const getQuestionEntries = (questions: Record<string, any> = {}) => {
  return Object.keys(questions)
    .sort()
    .map((key) => ({
      key,
      ...questions[key],
    }));
};

/**
 * Removes formatting characters from pricing values
 */
export const removePricingFormatting = (values: string[]): string[] => {
  return values.map((v) => v?.replace(/\$/g, "")?.replace(/-/g, ""));
};

/**
 * Gets employee size label from list
 */
export const getNoOfEmpLabel = (
  noOfEmpsList: any[],
  empId: string
): string => {
  return noOfEmpsList.find((item: any) => item?.id === empId)?.label || empId;
};
